import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('tag-pill')
export class TagPill extends LitElement {
    @property({ type: String })
    value?: string;

    @property({ type: Boolean })
    checked?: boolean;

    private handleClick(e: Event) {
        this.dispatchEvent(
            new CustomEvent('select', {
                detail: this.value,
            })
        );
    }

    protected render() {
        const containerClass = `pillItem${this.checked ?? false ? ' selected' : ''}`;

        return html`
            <div class="${containerClass}" @click=${this.handleClick}>
                <span class="pillTitle">${this.value?.replace('_', ' ')}</span>
            </div>
        `;
    }

    static get styles() {
        return css`
            .pillItem {
                display: flex;
                align-items: center;
                padding: 4px;
                background: var(--theme-border-color);
                border-radius: 40px;
                font-size: 12px;
                font-weight: 500;
                cursor: pointer;
                margin-right: 0.25rem;
                margin-bottom: 0.5rem;
            }

            .pillItem.selected {
                background: var(--main-primary-color);
                color: var(--theme-white-color);
            }

            .pillTitle {
                padding: 0 0.75rem;
            }
        `;
    }
}
